import { Component, ViewEncapsulation } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { ThemeModeToggleComponent } from '@portal-core/general/components/theme-mode-toggle/theme-mode-toggle.component';

@Component({
    selector: 'mc-full-navbar',
    templateUrl: './full-navbar.component.html',
    styleUrls: ['./full-navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbar, RouterOutlet, ThemeModeToggleComponent]
})
export class FullNavbarComponent { }
